//import 'babel-polyfill';
import "core-js";
import "regenerator-runtime/runtime";
import 'jquery';
import 'bootstrapsprocketsjs';
import 'bootstrapjs';
import AppRouter from './AppRouter';
import routes from './routing/routes';
import 'react-intl-tel-input/dist/libphonenumber.js';
import './cookieConsent'

import "react-select/scss/default.scss";
import "react-day-picker/lib/style.css";
import 'react-intl-tel-input/dist/main.css';
import './theme/scss/website.scss';

//import MyAccountButton from './my_account_button';
import startNewsletter from "./newsletter";

var router = new AppRouter(routes, 'fr', true);
router.resolveCurrentURL();

window.Router = router;

// all routes
//MyAccountButton();

